module.exports = __webpack_public_path__ + "socialOne-e4d7f4bd883e50a4141777b9dadcbb2f.png";